import React from 'react';
export function SectionDivider() {
  return <div className="flex items-center justify-center py-6 opacity-50" data-id="element-116">
      <div className="h-px w-16 bg-brand-line" data-id="element-117"></div>
      <span className="mx-4 text-xl" data-id="element-118">🕯️</span>
      <div className="h-px w-16 bg-brand-line" data-id="element-119"></div>
    </div>;
}